import { store } from "@betacrew/jars-flux";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { all, put, takeLatest } from "redux-saga/effects";
import FormsDataService from "../../../../../services/FormsDataService";
import { INTEGRATION_WRAPPER_LOADING_STATES } from "../constants";
import { componentKey as zohoComponentKey, setAuthorizationUrl, setFormAndTaxYearList, setFormSettings, setImportData, setIsImportDataGridViewLoaded, setLoadingState, setTenantList } from "./ZohoSlice";


export const { getZohoUrl, connectToZoho, getFormAndTaxYearList, getLoadImportData, getFormSetting } = {
    getZohoUrl: (payload) => {
        return {
            type: "ZOHO/GET_AUTHENTICATEURL",
            payload: payload
        }
    },
    connectToZoho: (payload) => {
        return {
            type: "ZOHO/GET_CONNECTXERO",
            payload: payload
        }
    },
    getFormAndTaxYearList: (payload) => {
        return {
            type: "ZOHO/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "ZOHO/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "ZOHO/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getZohoUrlAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.ZohoUrl();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setAuthorizationUrl(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Zoho Url", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* connectToZohoAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.connectZoho(action.payload);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            const tenantData = response?.data?.Data || [];
            yield put(setTenantList(tenantData));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to Connect Zoho", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setFormAndTaxYearList(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch TaxYear And Form Types", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setImportData(response?.data?.Data));
            yield put(setIsImportDataGridViewLoaded(true));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getFormSettingAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_LOADING }));
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getZohoUrl().type, getZohoUrlAsync),
        takeLatest(connectToZoho().type, connectToZohoAsync),
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}

store.sagaManager.addSaga(zohoComponentKey, rootSaga);